import type { GaVueComponent } from "@/common/vueUtils";

export function GaSpinner(): GaVueComponent {
  return <div class="spinner-border text-primary"></div>;
}
